<div class="invite-member-form">
  <ops-input
    [placeholder]="'auth.inviteMember.memberEmail' | translate"
    [value]="memberEmail"
    [isDisabled]="isPreview"
    (validationError)="onErrorHandler($event, 'memberEmail')"
    (changed)="onInputChange($event)"
    type="email"
  ></ops-input>

  <div class="action-buttons">
    <ops-select
      [isDisabled]="isPreview"
      [placeholder]="'auth.inviteMember.companyRole' | translate"
      [options]="roleOptions"
      mandatory="true"
      [defaultSelected]="memberRoleDisplay"
      [formName]="memberRoleDisplay"
      label=""
      (changed)="onRoleChange($event)"
    ></ops-select>
    <button
      [class.disabled]="isPreview"
      [disabled]="isPreview"
      (click)="resetInvite()"
      class="cancel-btn"
    >
      {{ 'auth.inviteMember.cancel' | translate }}
    </button>
    <button
      (click)="inviteMember()"
      [disabled]="isDisabled || isPreview"
      class="invite-btn"
      [class.disabled]="isDisabled || isPreview"
    >
      {{ 'auth.inviteMember.inviteMember' | translate }}
    </button>
  </div>
</div>
